export const messageError = '―';

export const getTypeTransaction = (value: number) => {
  if (value < 0) {
    return { desktop: 'DÉBITO', mobile: 'SAÍDA' };
  }
  return { desktop: 'CRÉDITO', mobile: 'ENTRADA' };
};
